/* eslint no-param-reassign: ["error", { "props": false }] */
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
/* eslint-disable camelcase */
import jwt_decode from 'jwt-decode';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState()],
  state: {
    isLogged: !!localStorage.getItem('token'),
    token: localStorage.getItem('token'),
    expiration: null,
    user: {},
    selected: {},
    commentsLength: null,
    reloadApp: null,
  },
  getters: {
    isLoggedIn: state => state.isLogged,
    selected: state => state.selected,
    user: state => state.user.name,
    token: state => state.token,
    commentsLength: state => state.commentsLength,
    reloadApp: state => state.reloadApp,
    id: state => state.id,
  },
  mutations: {
    login(state, token) {
      const data = jwt_decode(token);
      localStorage.setItem('token', token);
      state.token = token;
      state.isLogged = true;
      state.expiration = data.exp;
      state.user = data.user;
      state.reloadApp = data.user.reload_app;
      state.id = data.user_id;
    },
    logout(state) {
      state.isLogged = false;
      state.expiration = null;
      state.user = {};
      state.token = null;
      state.selected = {};
      state.reloadApp = null;
      state.id = null;
      localStorage.removeItem('token');
    },
    selectComplaint(state, complaint) {
      state.selected = complaint;
    },
    setCommentsLength(state, length) {
      state.commentsLength = length;
    },
    setReloadApp(state, value) {
      state.reloadApp = value;
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js